import { ReactNode } from 'react';
import { spacing } from '@lamimed/pantheon';

import * as S from './styles';

export type Spacing = keyof typeof spacing;

export interface ColumnRowProps {
  icon?: ReactNode;
  marginBottom?: Spacing;
  marginTop?: Spacing;
  reverse?: boolean;
}

export const ColumnRowView = ({
  icon,
  children,
  marginBottom = 'medium',
  marginTop,
  reverse,
}: React.PropsWithChildren<ColumnRowProps>) => {
  return (
    <S.IconWrapper
      marginBottom={marginBottom}
      marginTop={marginTop}
      reverse={reverse}
    >
      {icon}

      <S.ColumnRowWrapper>{children}</S.ColumnRowWrapper>
    </S.IconWrapper>
  );
};
